import axios, { AxiosInstance, AxiosError, AxiosRequestConfig } from 'axios';
import { AxiosRequestManager } from '../utils/AxiosRequestManager';
let isRefreshing = false;
let failedQueue: {
    resolve: (value?: any) => void;
    reject: (error: any) => void;
}[] = [];

const processQueue = (error: any, token: string | null = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};
const base_url = window.location.origin + '/';
const ax: AxiosInstance = axios.create({
    baseURL: base_url, // Replace with your API base URL
    // timeout: 1000000, // Timeout of 10 seconds,

});
export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    shouldCancelResponse?: boolean;  // Add custom flag to control canceling the response
}
// Add a request interceptor
ax.interceptors.request.use(
    (config: any) => {
        const controller = new AbortController();
        config.signal = controller.signal;

        const nonCancellableUrls = ["exam_management/exam_report_draft",
            "master_data/get_questions_types", "Auth/userinfo/",
            "/result/view-result", "exam_management/exam_start", "Auth/userinfo", "exam_management/examslots_list"];
        const allowMultiple = nonCancellableUrls.some((endpoint: any) =>
            config.url?.includes(endpoint)
        );

        const key = `${config.method}:${config.url}`;
        // Abort previous request if it exists
        // const existingController = AxiosRequestManager.getControllers(key);
        // if (existingController) {
        //     existingController.abort();
        // }
        // Abort only if not in allowMultiple list
        if (!allowMultiple) {
            const existingControllers = AxiosRequestManager.getControllers(key);
            if (existingControllers) {
                existingControllers.forEach(c => c.abort());
            }
            // AxiosRequestManager.addController(key, controller, false);
        }

        const token = localStorage.getItem('token');

        const formDataEndpoints = ['menu/addcandidate', 'menu/intern_app_form', 'master_data/candidate_bulk_upload', 'create-account', 'Account/candidate_bulk_upload',
            'master_data/questions_bulk_upload', 'menu/generate_account', 'upload', 'submit-public-form', 'bulk-upload', 'question-bulk-upload', 'Account/candidate_bulk_upload'];
        if (!formDataEndpoints.some((endpoint) => config.url.includes(endpoint))) {
            if (
                !config.url.includes('Auth/userlogin') &&
                !config.url.includes('api/login') &&
                !config.url.includes('auth/password_reset') &&
                !config.url.includes('auth/reset-password/verify-token') &&
                !config.url.includes('auth/password_reset/confirm/') &&
                !config.url.includes('exam_management/examurl') &&
                !config.url.includes('auth/password_reset') &&
                !config.url.includes('exam_management/examsubmit') &&
                !config.url.includes('menu/public_account') &&
                !config.url.includes('menu/degree_list') &&
                !config.url.includes('exam_management/exam_report_draft') &&
                !config.url.includes('exam_management/question_auto_gen_section_all') &&
                !config.url.includes('exam_management/exam_start') &&
                !config.url.includes('Exam/get_exam_uniqueid') &&
                !config.url.includes('Exam/get_exam_quesion') &&
                !config.url.includes('Exam/SubmitExam') &&
                !config.url.includes('Exam/save_examanswer_draft')

            ) {
                if (token) {
                    config.headers['Authorization'] = 'Bearer ' + token;
                    config.headers['Content-Type'] = 'application/json';
                    config.headers['Accept'] = 'application/json';
                }
            } else {
                config.headers['Content-Type'] = 'application/json';
                config.headers['Accept'] = 'application/json';
            }
        } else {
            if (token && !config.url.includes('menu/intern_app_form')) {
                config.headers['Authorization'] = 'Bearer ' + token;
            }
            // Only set Content-Type to multipart/form-data if the request data is FormData
            if (config.data instanceof FormData) {
                config.headers['Content-Type'] = 'multipart/form-data';
            } else {
                config.headers['Content-Type'] = 'application/json';
            }
            config.headers['Accept'] = 'application/json';
        }
        AxiosRequestManager.addController(key, controller, allowMultiple);
        return config;
    },
    (error:any) => {
        return Promise.reject(error);
    }
);

// Response interceptor - UPDATED VERSION
ax.interceptors.response.use(
    (response:any) => {
        const key = `${response.config.method}:${response.config.url}`;

        // Check if this is an allowMultiple request before removing
        const nonCancellableUrls = ["exam_management/exam_report_draft",
            "master_data/get_questions_types", "Auth/userinfo/",
            "/result/view-result", "exam_management/exam_start", "Auth/userinfo", "exam_management/examslots_list"];

        const allowMultiple = nonCancellableUrls.some((endpoint: any) =>
            response.config.url?.includes(endpoint)
        );

        // Only remove if not allowMultiple OR if it's a subsequent request of the same type
        if (!allowMultiple) {
            AxiosRequestManager.removeController(key);
        } else {
            console.log(``);
        }

        return response;
    },
    async (error: AxiosError & { config?: AxiosRequestConfig & { _retry?: boolean } }) => {
        // Don't remove controller if request was aborted - it might be intentional
        if (error.name !== 'CanceledError' && error.name !== 'AbortError') {
            const key = `${error.config?.method}:${error.config?.url}`;
            AxiosRequestManager.removeController(key);
        }

        const originalRequest = error.config;

        if (
            error.response?.status === 401 &&
            originalRequest &&
            !originalRequest._retry &&
            !originalRequest.url?.includes('/api/refresh-token')
        ) {
            // ... rest of your 401 handling code stays the same
            originalRequest._retry = true;

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then((token) => {
                    if (token && originalRequest.headers) {
                        originalRequest.headers['Authorization'] = `Bearer ${token}`;
                    }
                    return axios(originalRequest);
                });
            }

            isRefreshing = true;
            const Token = localStorage.getItem('refreshToken');
            const token = localStorage.getItem('token');
            const userName = localStorage.getItem('userName');

            const inputJson = {
                // username: userName,
                // userid: localStorage.getItem('appUserID'),
                // access_token: localStorage.getItem('accessToken'),
                RefreshToken: Token,
                // expires: localStorage.getItem('expiryDate'),
                appuserid: localStorage.getItem('appUserID')
            }

            try {
                console.log("Sending refresh token request...");
                const refreshResp = await axios.post('/api/refresh-token', { inputJson }, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                console.log("Refresh Token Response:", refreshResp.data);
                const { token: access_token, refreshToken: refresh_token, expires } = refreshResp.data.data;

                localStorage.setItem('token', access_token);
                localStorage.setItem('refreshToken', refresh_token);
                localStorage.setItem('expiryDate', expires);

                processQueue(null, access_token);

                if (originalRequest.headers) {
                    originalRequest.headers['Authorization'] = `Bearer ${access_token}`;
                }

                return axios(originalRequest);
            } catch (refreshErr) {
                console.error("Refresh token error:", refreshErr);
                processQueue(refreshErr, null);
                localStorage.clear();
                window.location.href = '/login';
                return Promise.reject(refreshErr);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);

export default ax;
